module.exports = __webpack_public_path__ + "img/a1252d0.png";